<div class="space-y-4">
  <div class="flex items-center justify-between">
    <h3
      class="text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide"
    >
      Variantes
    </h3>
    <button
      type="button"
      (click)="abrirCrear()"
      class="px-2.5 py-1 text-xs rounded-md font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1"
    >
      <svg
        class="w-3 h-3"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 4v16m8-8H4"
        ></path>
      </svg>
      Nueva Variante
    </button>
  </div>

  @if (error) {
    <div
      class="p-3 bg-error-50 border border-error-200 rounded-lg dark:bg-error-900/20 dark:border-error-800"
    >
      <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  }

  @if (loading) {
    <div class="flex items-center gap-2 text-gray-500 dark:text-gray-400 py-4">
      <div
        class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"
      ></div>
      <span class="text-sm">Cargando variantes...</span>
    </div>
  } @else if (variants.length === 0) {
    <p class="text-sm text-gray-500 dark:text-gray-400 py-4 text-center">
      No hay variantes registradas.
    </p>
  } @else {
    <div class="overflow-x-auto">
      <table class="min-w-full text-xs">
        <thead>
          <tr class="border-b border-gray-200 dark:border-gray-700">
            <th
              class="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400"
            >
              Imagen
            </th>
            <th
              class="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400"
            >
              SKU
            </th>
            <th
              class="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400"
            >
              Nombre
            </th>
            <th
              class="px-3 py-2 text-left font-medium text-gray-500 dark:text-gray-400"
            >
              Atributos
            </th>
            <th
              class="px-3 py-2 text-start font-medium text-gray-500 dark:text-gray-400"
            >
              Precio efectivo
            </th>
            <th
              class="px-3 py-2 text-center font-medium text-gray-500 dark:text-gray-400"
            >
              Stock
            </th>
            <th
              class="px-3 py-2 text-center font-medium text-gray-500 dark:text-gray-400"
            >
              Activa
            </th>
            <th class="px-3 py-2"></th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-gray-700/50">
          @for (variant of variants; track variant.id) {
            <tr [class.opacity-60]="!variant.isActive">
              <td class="px-3 py-2">
                @if (variant.imageUrl) {
                  <img
                    [src]="variant.imageUrl"
                    [alt]="variant.sku"
                    class="w-9 h-9 rounded object-cover border border-gray-200 dark:border-gray-700"
                  />
                } @else {
                  <div
                    class="w-9 h-9 rounded bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-gray-300 dark:text-gray-500"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                  </div>
                }
              </td>
              <td class="px-3 py-2 font-mono text-gray-600 dark:text-gray-300">
                {{ variant.sku }}
              </td>
              <td class="px-3 py-2 text-gray-800 dark:text-white">
                {{ variant.name || '-' }}
              </td>
              <td class="px-3 py-2 text-gray-500 dark:text-gray-400">
                {{ variant.attributesSummary || '-' }}
              </td>
              <td
                class="px-3 py-2 text-start font-semibold text-brand-600 dark:text-brand-400"
              >
                {{ formatPrecio(variant.effectivePrice) }}
              </td>
              <td class="px-3 py-2 text-center text-gray-800 dark:text-white">
                {{ variant.stockQuantity ?? '-' }}
              </td>
              <td class="px-3 py-2 text-center">
                @if (variant.isActive) {
                  <span
                    class="inline-flex h-2 w-2 rounded-full bg-success-400"
                  ></span>
                } @else {
                  <span
                    class="inline-flex h-2 w-2 rounded-full bg-gray-300 dark:bg-gray-600"
                  ></span>
                }
              </td>
              <td class="px-3 py-2">
                <div class="flex items-center gap-1 justify-end">
                  <button
                    type="button"
                    (click)="abrirEditar(variant)"
                    class="rounded p-1 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                    title="Editar"
                  >
                    <svg
                      class="w-3.5 h-3.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    (click)="eliminar(variant)"
                    class="rounded p-1 hover:bg-error-50 hover:text-error-600 text-gray-400"
                    title="Eliminar"
                  >
                    <svg
                      class="w-3.5 h-3.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      ></path>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>

<!-- Modal crear/editar variante -->
@if (showModal) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
  >
    <div
      class="w-full max-w-lg bg-white dark:bg-gray-900 rounded-xl shadow-xl overflow-hidden"
    >
      <div
        class="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700"
      >
        <h3 class="text-base font-semibold text-gray-900 dark:text-white">
          {{ editingVariant ? 'Editar Variante' : 'Nueva Variante' }}
        </h3>
        <button
          type="button"
          (click)="cerrarModal()"
          class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
        >
          <svg
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>
      <div class="p-5 space-y-4 max-h-[70vh] overflow-y-auto">
        @if (error) {
          <div
            class="p-3 bg-error-50 border border-error-200 rounded-lg dark:bg-error-900/20 dark:border-error-800"
          >
            <p class="text-sm text-error-600 dark:text-error-400">
              {{ error }}
            </p>
          </div>
        }
        <div class="grid grid-cols-2 gap-3">
          <div>
            <label
              class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
              >SKU (opcional)</label
            >
            <input
              type="text"
              [(ngModel)]="form.sku"
              placeholder="Auto-generado"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            />
          </div>
          <div>
            <label
              class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
              >Nombre (opcional)</label
            >
            <input
              type="text"
              [(ngModel)]="form.name"
              placeholder="Nombre de variante"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            />
          </div>
          <div>
            <label
              class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
              >Precio override</label
            >
            <input
              type="number"
              [(ngModel)]="form.priceOverride"
              min="0"
              step="0.01"
              placeholder="-"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            />
          </div>
          <div>
            <label
              class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
              >Recargo de precio</label
            >
            <input
              type="number"
              [(ngModel)]="form.priceSurcharge"
              min="0"
              step="0.01"
              placeholder="-"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            />
          </div>
          <div>
            <label
              class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
              >Costo</label
            >
            <input
              type="number"
              [(ngModel)]="form.cost"
              min="0"
              step="0.01"
              placeholder="-"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            />
          </div>
          <div>
            <label
              class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
              >Stock</label
            >
            <input
              type="number"
              [(ngModel)]="form.stockQuantity"
              min="0"
              placeholder="-"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
            />
          </div>
        </div>

        <!-- Inc 41: Imagen de la variante -->
        <div>
          <label
            class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
            >Imagen de la variante</label
          >
          <div class="flex items-center gap-3">
            @if (form.imageUrl) {
              <img
                [src]="form.imageUrl"
                alt="Variante"
                class="w-14 h-14 rounded-lg object-cover border border-gray-200 dark:border-gray-700"
              />
            } @else {
              <div
                class="w-14 h-14 rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-gray-300 dark:text-gray-500"
              >
                <svg
                  class="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                  ></path>
                </svg>
              </div>
            }
            <div class="flex flex-col gap-1.5">
              <label
                class="cursor-pointer px-2.5 py-1 text-xs rounded-md font-medium bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600"
                [class.opacity-50]="uploadingImage"
              >
                {{
                  uploadingImage
                    ? 'Subiendo...'
                    : form.imageUrl
                      ? 'Cambiar imagen'
                      : 'Subir imagen'
                }}
                <input
                  type="file"
                  class="hidden"
                  accept="image/png,image/jpeg,image/webp"
                  (change)="onImageSelected($event)"
                  [disabled]="uploadingImage"
                />
              </label>
              @if (form.imageUrl) {
                <button
                  type="button"
                  (click)="quitarImagen()"
                  class="px-2.5 py-1 text-xs rounded-md font-medium bg-error-50 text-error-600 hover:bg-error-100 dark:bg-error-500/10 dark:text-error-400 text-left"
                >
                  Quitar imagen
                </button>
              }
            </div>
          </div>
        </div>

        <!-- Activa -->
        <label class="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            [(ngModel)]="form.isActive"
            class="h-4 w-4 rounded border-gray-300 text-brand-500 dark:border-gray-600 dark:bg-gray-800"
          />
          <span class="text-sm text-gray-700 dark:text-gray-300"
            >Variante activa</span
          >
        </label>

        <!-- Selección de valores de atributo -->
        @if (allAttributes.length > 0) {
          <div>
            <label
              class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-2"
              >Valores de atributo</label
            >
            <div class="space-y-2">
              @for (attr of allAttributes; track attr.id) {
                <div>
                  <p
                    class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1"
                  >
                    {{ attr.name }}
                  </p>
                  <div class="flex flex-wrap gap-1.5">
                    @for (val of attr.values; track val.id) {
                      <button
                        type="button"
                        (click)="toggleAttributeValue(val.id)"
                        class="px-2 py-0.5 text-xs rounded-full border transition-colors"
                        [class.border-brand-400]="isValueSelected(val.id)"
                        [class.bg-brand-50]="isValueSelected(val.id)"
                        [class.text-brand-700]="isValueSelected(val.id)"
                        [class.dark:bg-brand-900/20]="isValueSelected(val.id)"
                        [class.dark:text-brand-300]="isValueSelected(val.id)"
                        [class.border-gray-200]="!isValueSelected(val.id)"
                        [class.text-gray-600]="!isValueSelected(val.id)"
                        [class.dark:border-gray-600]="!isValueSelected(val.id)"
                        [class.dark:text-gray-400]="!isValueSelected(val.id)"
                      >
                        {{ val.value }}
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div
        class="flex items-center justify-end gap-3 px-5 py-4 border-t border-gray-200 dark:border-gray-700"
      >
        <button
          type="button"
          (click)="cerrarModal()"
          class="px-4 py-2 text-sm rounded-lg font-medium bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
        >
          Cancelar
        </button>
        <button
          type="button"
          (click)="guardar()"
          [disabled]="saving"
          class="px-4 py-2 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{
            saving ? 'Guardando...' : editingVariant ? 'Actualizar' : 'Crear'
          }}
        </button>
      </div>
    </div>
  </div>
}
